import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';
import { Deserializable } from '../protocols/deserializable';
import { Account } from '../transactions/account';
import { MemberUser } from '../users/dto/member-user';

export class RemittanceEmployer implements Deserializable {
  public id!: number;
  public name!: string;
  public planId!: number;
  public governingJurisdictionId!: number;
  public governingJurisdiction!: GoverningJurisdictionType;
  public accounts!: Account[];
  public users!: MemberUser[];

  // Not From API
  public displayableId!: string;

  public onDeserialize() {
    if (!!this.governingJurisdiction) {
      this.governingJurisdiction = window?.injector?.Deserialize.instanceOf(
        GoverningJurisdictionType,
        this.governingJurisdiction
      );
    }
    if (!!this.accounts) {
      this.accounts = window?.injector?.Deserialize.arrayOf(Account, this.accounts);
    }
    if (!!this.users) {
      this.users = window?.injector?.Deserialize.arrayOf(MemberUser, this.users);
    }

    this.displayableId = this.id.toString().padStart(8, '0');
  }
}
